<template>
    <div class="chat-attendance-products-component">
        <vs-popup title="" 
            :button-close-hidden="true" 
            :active.sync="isActive" 
            @close="$emit('isActiveFalse')"
            style="border-radius: 10px !important;"
            id="popUpCustomerDocument"
            :sst="true"
            class="sizePopup"
        >
            <div>
                <span id="display-span-erps">
                    <vs-icon @click="back()" class="mr-2" icon="keyboard_arrow_left" style="border: solid 1px; border-radius: 14px; cursor: pointer;"/>
                    <p class="ml-2" style="font-size: 16px; width: 400px;">Documento do Cliente</p>
                    <div class="flex-end-align">
                        <vs-icon @click="closePopUp" class="mr-2" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right;"></vs-icon>
                    </div>
                </span>                
            </div>

            <div id="customer-document-div">
                <div :class="{'div-customer-ios': isIos, 'div-customer-android': isAndroid}">
                    <span> CPF ou CNPJ <span>({{ context === 'finish' ? 'obrigatório': 'opcional' }})</span></span>
                    <vs-input
                    class="bigSizeOfInput mt-2"
                    placeholder="Digite o CPF ou CNPJ do cliente"
                    type="text"
                    v-model="document"
                    v-mask="['###.###.###-X#','##.###.###/####-##']"/>
                </div>
            </div>
              
            <vs-button 
                @click="continueFlow" 
                class="btn-drop px-3 mr-6 mt-3" 
                type="filled" icon="keyboard_arrow_right" 
                icon-after style="float: right !important; border-radius: 12px;"
            >
                Próximo
            </vs-button>
        </vs-popup>
    </div>
</template>

<script>
    import CustomerApi from '@/http/requests/customer';
    
    export default {
        name: 'CustomerDocumentPopUp',

        data() {
            return {
                customer: [],
                document: ''
            }
        },
        computed:{
            isIos() {
                return window.innerWidth <= 430 && window.innerHeight <= 932;
            },
            isAndroid() {
                return window.innerWidth <= 393 && window.innerHeight <= 873;
            },
        },
        methods: {
            async closePopUp() {
                this.isActive = false;
                this.$emit('isActiveFalse');
                this.dataLoad();
            },
            async continueFlow() {
                var data = this.dataOfProductsToPreOrder;
                
                let cleanDocument = this.document;
                cleanDocument = cleanDocument.replace(/[./-]/g, '');
                cleanDocument = cleanDocument.toUpperCase();

                if (this.document !== '' && ((![11, 14, 10].includes(cleanDocument.length)) ||
                    (cleanDocument.length === 10 && cleanDocument.charAt(9) !== 'X'))) {
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Aviso:',
                        text: 'Digite um CPF ou CNPJ válido'
                    });
                }
                else if (cleanDocument !== this.chatTicket.document_register && cleanDocument !== '') {
                    
                    this.chatTicket.customer.document_register = cleanDocument;
                    this.chatTicket.document_register = cleanDocument;
                    this.customer.document_register   = cleanDocument;

                    await CustomerApi.update({customer: this.chatTicket.customer, chosenGroups: []})
                    .then((response) => {
                        console.log("CPF/CNPJ Atualizado com Sucesso",response)
                    })
                    .catch((error) => {
                        console.log("Ocorreu um erro ao atualizar o CPF/CNPJ",error)
                    });

                }

                if(this.context === 'finish') {
                    return this.$emit('backToFinishOrder');
                }
               
                this.outOfChat 
                ? this.$emit('sendToProductSericesFlow', data)
                : this.$emit('sendToProductFlow', data);
                
            },
            formatDocument(newVal) {
                if (newVal.length <=11) {
                    this.document = newVal.substring(0,3) + '.' +
                    newVal.substring(3,6) + '.' +
                    newVal.substring(6,9) + '-' +
                    newVal.substring(9,11)
                }
                else if (newVal.length <=14) {
                    this.document = newVal.substring(0, 2) + '.' +
                    newVal.substring(2, 5) + '.' +
                    newVal.substring(5, 8) + '/' +
                    newVal.substring(8, 12) + '-' +
                    newVal.substring(12, 14);
                }
            },
            dataLoad() {
                this.document = this.customer ? this.customer.document_register || '' : this.chatTicket.customer.document_register || '';
            },
            back() {
                if (this.context === 'finish') {
                    this.$emit('backToFinishOrder');
                    return;
                }
                this.outOfChat ? this.$emit('backToCustomer') : this.$emit('backToPreOrders')
            }
        },
        mounted() {
            this.dataLoad();
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            dataOfProductsToPreOrder: {
                type: Array|Object,
                required: true
            },
            chatTicket: {
                type: Array|Object,
                required: true
            },
            dataToUpdate: {
                type: Array|Object,
                required: true
            },
            isCreateContext: {
                type: Boolean,
                required: true
            },
            outOfChat: {
                type: Boolean,
                default: false
            },
            customer: {
                type: Object,
                default: null
            },
            context: {
                type: String,
                default: ''
            },
        },
        emits: [
            'isActiveFalse',
            'backToPreOrders',
            'sendToProductSericesFlow',
            'sendToProductFlow',
        ],
        watch: {
            async isActive() {
              this.dataLoad()
              if (this.document !== '') {
                this.formatDocument(this.document);
              }
            }
        }
    }
</script>

<style>
#customer-document-div {
    margin-top: 30px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

#customer-document-div div input.vs-inputx.vs-input--input.normal {
    border-radius: 14px !important;
}

#customer-document-div div span span {
    color: #8c8c8c;
}

</style>

<style lang="scss">
#popUpCustomerDocument div.vs-popup {
    .vs-popup--content {
        padding: 12px;
        margin: 0;
    }
    margin: 0;
    border-radius: 18px !important;
    border: solid 1.2px;
    border-color: rgba(18, 17, 17, 0.769);
    width: 650px !important;
    .vs-popup--header {
        background-color: transparent !important;
        .vs-popup--title {
            background-color: transparent !important;
            h3 {
                background-color: transparent !important;
            }
        }
    }
    header {
        background-color: transparent !important;

    }
    .bigSizeOfInput.mt-2 {
        width: 410px !important;
    }
    
}
#display-span-erps {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    div {
        display: flex;
        justify-content: flex-end;
        width: 97%;
        i.vs-icon.notranslate.icon-scale.mr-2.material-icons.null:last-of-type {
            cursor: pointer;
        }
    }

}

.div-customer-ios{
    padding-left: 40px;
}

.div-customer-android{
    padding-left: 40px;
}

.input-customer-android{
    width: 50px;
}

.input-customer-ios{
    width: 50px;
}
</style>
